import PropTypes from 'prop-types';
import clsx from 'clsx';

const Input = ({
  as: Component = 'input',
  error = false,
  disabled = false,
  className,
  ...props
}) => {
  return (
    <Component
      className={clsx(
        'input',
        error && 'input-error',
        disabled && 'input-disabled',
        Component === 'textarea' && 'input-textarea',
        className
      )}
      disabled={disabled}
      {...props}
    />
  );
};

Input.propTypes = {
  as: PropTypes.oneOf(['input', 'textarea']),
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default Input;